import { Injectable } from '@angular/core';

import {Observable} from 'rxjs/Observable';

@Injectable()
export class PurchaseHandlerProvider {
	observers: any = [];
	subscription: any;

	constructor() {
		this.subscription = Observable.create(observer => {
		  this.observers.push(observer);
		});	
	}

	purchaseProduct(params){
  		if(this.observers){ 
			for (var i = this.observers.length - 1; i >= 0; i--) {
				this.observers[i].next(params);
			}
  		}			
	}	
}



// WEBPACK FOOTER //
// ./src/providers/purchase-handler.ts